module.exports = __webpack_public_path__ + "img/P1.bded1093.png";